class EditorialMenu extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const activate = (link) => {
      for (const item of this.querySelectorAll('[data-category]')) {
        const active = item === link;
        item.classList.toggle('is-active', active);
        if (item.hasAttribute('aria-expanded')) item.setAttribute('aria-expanded', String(active));
      }
      for (const panel of this.querySelectorAll('[data-panel]')) panel.hidden = panel.dataset.panel !== link.dataset.category;
    };
    this.addEventListener('pointerover', (event) => {
      const link = event.target.closest('[data-category]');
      if (link && event.pointerType !== 'touch') activate(link);
    }, options);
    this.addEventListener('focusin', (event) => {
      const link = event.target.closest('[data-category]');
      if (link) activate(link);
    }, options);
    this.addEventListener('keydown', (event) => {
      const link = event.target.closest('[data-category]');
      if (!link || !['ArrowDown', 'ArrowUp', 'ArrowRight'].includes(event.key)) return;
      const links = [...this.querySelectorAll('[data-category]')];
      event.preventDefault();
      if (event.key === 'ArrowRight') this.querySelector('[data-panel]:not([hidden]) a')?.focus();
      else links[(links.indexOf(link) + (event.key === 'ArrowDown' ? 1 : links.length - 1)) % links.length].focus();
    }, options);
  }
  disconnectedCallback() { this.controller?.abort(); }
}
class EditorialSearchHistory extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const form = this.closest('form');
    const input = form.querySelector('[name="q"]');
    const key = 'prestige-search-history';
    let terms = [];
    try { const stored = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(stored)) terms = stored.filter(x => typeof x === 'string').slice(0, 5); } catch {}
    const save = () => { try { localStorage.setItem(key, JSON.stringify(terms)); } catch {} };
    const render = () => {
      this.replaceChildren();
      this.hidden = !terms.length;
      if (!terms.length) return;
      const label = document.createElement('span'); label.textContent = 'Recent searches:'; this.append(label);
      for (const term of terms) {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = term;
        button.addEventListener('click', () => { input.value = term; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); });
        this.append(button);
      }
      const clear = document.createElement('button'); clear.type = 'button'; clear.textContent = 'Clear history';
      clear.addEventListener('click', () => { terms = []; save(); render(); }); this.append(clear);
    };
    form.addEventListener('submit', () => { const term = input.value.trim().slice(0, 100); if (term) { terms = [term, ...terms.filter(x => x !== term)].slice(0, 5); save(); render(); } }, { signal: this.controller.signal });
    render();
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('editorial-menu')) customElements.define('editorial-menu', EditorialMenu);
if (!customElements.get('editorial-search-history')) customElements.define('editorial-search-history', EditorialSearchHistory);

class EditorialCategorySuggestions extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const form = this.closest('form');
    const input = form.querySelector('[name="q"]');
    const list = this.querySelector('ul');
    const items = [...list.children];
    const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const update = () => {
      const term = normalize(input.value);
      const seen = new Set();
      let count = 0;
      const ranked = items.map((item, index) => {
        const link = item.querySelector('a');
        const title = normalize(link.textContent);
        const score = /^(see|view|shop) all\b/.test(title) && title.includes(term) ? -1 : title.startsWith(term) ? 0 : title.split(/\s+/).some(word => word.startsWith(term)) ? 1 : 2;
        return { item, link, title, score, index };
      }).sort((a, b) => a.score - b.score || a.index - b.index);
      for (const { item, link, title } of ranked) {
        const match = term.length > 0 && title.includes(term) && !seen.has(link.href) && count < 8;
        item.hidden = !match;
        if (match) { seen.add(link.href); count++; }
        list.append(item);
      }
      this.hidden = count === 0;
      this.querySelector('[data-category-count]').textContent = term ? `${count} matching categories` : '';
    };
    form.addEventListener('input', update, { signal: this.controller.signal });
    form.addEventListener('reset', () => queueMicrotask(update), { signal: this.controller.signal });
    form.addEventListener('click', () => queueMicrotask(update), { signal: this.controller.signal });
    update();
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('editorial-category-suggestions')) customElements.define('editorial-category-suggestions', EditorialCategorySuggestions);
